/**
 * Copyright (c) 2020 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { REPLACE_PDF_DOC, SELECT_FILE, SELECT_PDF_DOC } from '../../../const';

const DocumentPdfInput = ({
  loading,
  pdfFileInputRef,
  pdfFile,
  setPdfFile,
  setError,
  onPdfInputChange,
  replaceFile
}) => {
  return (
    <div
      className="field-wrapper file-field"
      tabIndex={0}
      onKeyDown={(evt) => {
        switch (evt.key) {
          case 'Enter': {
            !loading && pdfFileInputRef && pdfFileInputRef.current && pdfFileInputRef.current.click();

            break;
          }
          case 'Delete': {
            setPdfFile(null);
            setError(null);

            break;
          }
        }
      }}
    >
      <label className="field-label">{replaceFile ? REPLACE_PDF_DOC : SELECT_PDF_DOC}</label>
      {pdfFile ? (
        <label className="choose-file-document-file-label has-file" title={pdfFile.name}>
          {pdfFile.name}
          <span
            className="material-icons remove"
            onClick={(e) => {
              e.preventDefault();
              !loading && setPdfFile(null);
              !loading && setError(null);
            }}
          >
            highlight_off
          </span>
        </label>
      ) : (
        <div>
          <label className="choose-file-document-file-label" htmlFor="pdf-document-file-input">
            {SELECT_FILE}
          </label>
          <input
            type="file"
            accept=".pdf, application/pdf"
            id="pdf-document-file-input"
            className="choose-file-document-input"
            onChange={onPdfInputChange}
            placeholder="Choose file"
            ref={pdfFileInputRef}
            disabled={loading}
          />
        </div>
      )}
    </div>
  );
};

DocumentPdfInput.propTypes = {
  loading: PropTypes.bool,
  pdfFileInputRef: PropTypes.object,
  pdfFile: PropTypes.object,
  setPdfFile: PropTypes.func,
  setError: PropTypes.func,
  onPdfInputChange: PropTypes.func,
  replaceFile: PropTypes.bool
};

export default DocumentPdfInput;
